import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blank-new',
  templateUrl: './blank-new.component.html',
  styleUrls: ['./blank-new.component.scss']
})
export class BlankNewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
